module.exports = __webpack_public_path__ + "static/fg-f2d3d55ba3f70f765dbdd27f7c21fddb.png";